import { Component } from '@angular/core';

@Component({
  selector: 'app-myaha-shimmer',
  templateUrl: './myaha-shimmer.component.html',
  styleUrls: ['./myaha-shimmer.component.scss'],
})
export class MyAhaShimmerComponent {
  trackByIndex(index: number, item: any): number {
    return index;
  }
}
